import React from "react";
import { Link, NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-light"
      style={{
        backgroundColor: "#1D4857", // Dark teal tone from the uploaded image
        borderBottom: "3px solid #0f2f36", // Slightly darker accent for separation
        padding: "0.75rem 1rem",
      }}
    >
      <div className="container-fluid">
        <Link
          to="/"
          className="navbar-brand nav-link-item head-name"
          style={{
            color: "#ffffff", // White text for contrast
            fontFamily: "Times New Roman",
            fontSize: "2rem",
            fontWeight: "bold",
            textDecoration: "none", // Remove underline from Link
          }}
        >
          NeuralSBM
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            {/* Future Nav Items */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
